module.exports = __webpack_public_path__ + "media/images/landing/stand-alone-d420669e436d5d2d1a7e436125e7f0f5.png";